import React from 'react';
import { useApp } from '../../context/AppContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { Button } from '../ui/Button';
import { Separator } from '../ui/Separator';

export const Header = () => {
  const { toggleSidebar, data } = useApp();
  const urgentAlert = data.alerts.find(a => a.severity === 'critical');

  return (
    <header className="h-16 bg-card border-b border-border fixed top-0 right-0 left-64 z-40 px-6 flex items-center justify-between">
      <div className="flex items-center gap-4">
        <Button
          variant="ghost"
          size="icon"
          onClick={toggleSidebar}
          className="text-muted-foreground"
        >
          <SafeIcon icon={FiIcons.FiMenu} className="text-xl" />
        </Button>

        {urgentAlert && (
          <div className="hidden md:flex items-center gap-2 px-3 py-1.5 bg-destructive/10 border border-destructive/20 rounded-md">
            <SafeIcon icon={FiIcons.FiAlertCircle} className="text-destructive text-sm" />
            <span className="text-xs font-semibold text-destructive">CRITICAL: {urgentAlert.title}</span>
          </div>
        )}
      </div>

      <div className="flex items-center gap-6">
        <div className="hidden md:block text-right">
          <p className="text-xs text-muted-foreground font-medium">System Time</p>
          <p className="text-sm font-bold text-foreground font-mono">
            {new Date().toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}
          </p>
        </div>

        <Separator orientation="vertical" className="h-8" />

        <div className="flex items-center gap-2">
          <Button variant="ghost" size="icon" className="relative text-muted-foreground">
            <SafeIcon icon={FiIcons.FiBell} />
            <span className="absolute top-1.5 right-1.5 h-2 w-2 bg-destructive rounded-full border border-card"></span>
          </Button>
          <Button variant="ghost" size="icon" className="text-muted-foreground">
            <SafeIcon icon={FiIcons.FiHelpCircle} />
          </Button>
        </div>
      </div>
    </header>
  );
};